/**
 * baseQuerySchema — 목록 API 공통 쿼리 스키마 (필터 + 정렬 + 페이지네이션)
 *
 * baseFilterSchema에 sortKey / sortType을 추가한 버전.
 * antdQuerySchema() 대체용으로 설계되었다.
 *
 * @example
 * const schema = baseQuerySchema.extend({
 *   deliveryKey: z.coerce.number().int().positive().optional(),
 * });
 * const data = parseRequestParams(req, schema);
 * // data.keyword, data.page, data.sortKey, data.sortType ...
 */

import { z } from "zod";
import { baseFilterSchema } from "./base-filter";

export const baseQuerySchema = baseFilterSchema.extend({
    /** 정렬 컬럼 키 (프로젝트에서 sortColumns 맵으로 실제 컬럼명에 매핑) */
    sortKey: z.string().default(""),
    /** 정렬 방향 */
    sortType: z.enum(["ASC", "DESC", "asc", "desc"]).optional(),
});

export type BaseQuery = z.infer<typeof baseQuerySchema>;
